import { useTranslation } from 'react-i18next';

import useAppModal from 'hooks/useAppModal';
import ScheduledMessagesEditModal from './ScheduledMessagesEditModal';

const modalId = 'scheduled-messages-edit-modal';

const useScheduledMessagesEditModal = () => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();

  const openEditScheduledMessagesModal = ({
    scheduledMessageUid,
  }: {
    scheduledMessageUid: string;
  }) => {
    openModal({
      customContent: (
        <ScheduledMessagesEditModal scheduledMessageUid={scheduledMessageUid} />
      ),
      id: modalId,
      title: t('pageAutomations.scheduledMessages.modal.title'),
    });
  };

  return { openEditScheduledMessagesModal };
};

export default useScheduledMessagesEditModal;
